import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChatBox from "../chatBox";
import { UserContext } from "../../../../../../context/user/userContext";
import MksChatContext from "../../../../context/mksContext";
import { DisableFollowupQuestions, getSkillModelData } from "../../../services/chatService.js";
import { getStorageToken } from "../../../../../../services/tokenService";
import { UserProfile } from "../../../../../../services/authService";
import SelectBySkillModel from "../../../../../common/selectSkillModel/index.js";

const ChatTerminalHeader = (props) => {
  const { isMKSChatSelected, chatMessage, setIsSkillChat, isFileType, skillStoreId, matchedSkill, skillData } = props;

  const [isMKSChat, setIsMKSChat] = useState(isMKSChatSelected);
  const [message, setMessage] = useState(chatMessage);
  const [defaultSkillWelMessage, setDefaultSkillWelMessage] = useState(false);
  const [isClearChat, setIsClearChat] = useState(false);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const [isFileTypeChat, setIsFileTypeChat] = useState(isFileType);
  const [isMKSProcessing, setIsMKSProcessing] = useState(false);
  const [isSkillProcessing, setIsSkillProcessing] = useState(false);
  const [isMessageTyping, setIsMessageTyping] = useState(false);
  const [disableRegenerateButton, setDisableRegenerateButton] = useState(true);
  const [disableStopGenerateButton, setDisableStopGenerateButton] =
    useState(true);
  const [showFollowupQuestion, setShowFollowupQuestion] = useState(false);
  const [disableFolloupButton, setDisableFolloupButton] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [isAllowedMessageStreaming, setIsAllowedMessageStreaming] =
    useState(false);
  const [models, setModels] = useState([]);
  const [selectedModelName, setSelectedModelName] = useState("");
  const [selectedModelId, setSelectedModelId] = useState("");
  var context = useContext(MksChatContext);
  const { isMksChatEnable, isSkillChatEnable } = context;

  const navigate = useNavigate();

  useEffect(() => {
    if (isMksChatEnable && isMKSChat) handleMKSChat();
    else {
      handleSkillChat();
    }
  }, [isMksChatEnable]);

  useEffect(() => {
    if (matchedSkill) {
      setSelectedSkill(matchedSkill);
    }
  }, [matchedSkill]);

  useEffect(() => {
    if (chatMessage) {
      setMessage(chatMessage);
    }
    else {
      setMessage("");
    }
  }, [chatMessage]);

  useEffect(() => {
    const getUserProfile = async () => {
      const token = getStorageToken();
      const res = await UserProfile(token);
      setIsAllowedMessageStreaming(
        res?.AllowMessageStreaming ? res?.AllowMessageStreaming : false
      );
    };

    getUserProfile();
  }, []);

  useEffect(() => {
    const getModelInfo = async () => {
      const data = await getSkillModelData(selectedSkill.Id)
      if (data) {
        setModels(data);
        if (data?.length > 0) {
          setSelectedModelId(data[0].Id);
          setSelectedModelName(data[0].Name)
        }
        else if (data?.length === 0 || data === undefined) {
          setSelectedModelId("");
          setSelectedModelName("")
        }
      }
    };
    if (selectedSkill && selectedSkill?.ChatbotConfiguration?.InputType?.toLowerCase() !== "file")
      getModelInfo();
    else {
      setSelectedModelId("");
      setSelectedModelName("");
      setModels([]);
    }
  }, [selectedSkill]);

  const handleMKSChat = () => {
    if (!isMKSChat) {
      setIsMKSChat(true);
      setMessage("");
      setDefaultSkillWelMessage(true);
      setOpenPdfViewer(false);
      setIsFileTypeChat(false);
      setDisableRegenerateButton(true);
      setDisableStopGenerateButton(true);
      navigate("/chat", {
        state: {
          isMKSChat: true,
          message: "",
          isFileTyple: false,
        },
      });
    }
  };
  const handleSkillChat = () => {
    if (isMKSChat) {
      setIsMKSChat(false);
      if (chatMessage)
        setMessage(chatMessage);
      else
        setMessage("");
      if (!matchedSkill) {
        setDefaultSkillWelMessage(true);
      }
      else {
        setDefaultSkillWelMessage(false);
      }
      setIsFileTypeChat(false);
      setDisableRegenerateButton(true);
      setDisableStopGenerateButton(true);
      if (skillStoreId !== undefined) {
        navigate(`/chat/${skillStoreId}`, {
          state: {
            isMKSChat: false,
            message: "",
            isFileTyple: false,
          },
        });
      }
      else {
        navigate("/chat", {
          state: {
            isMKSChat: false,
            message: "",
            isFileTyple: false,
          },
        });
      }
    }
  };

  const showHideClearChatBtn = (isChatVisible) => {
    setIsChatVisible(isChatVisible);
  };

  const clearChat = () => {
    setIsClearChat(true);
    setIsSkillProcessing(false);
    setIsMKSProcessing(false);
    setOpenPdfViewer(false);
    setDisableRegenerateButton(true);
    setDisableStopGenerateButton(true);
  };

  const disabledFollowupButton = () => {
    const data = {
      SkillStoreId: selectedSkill.Id,
      Status: disableFolloupButton ? false : true,
    };
    DisableFollowupQuestions(data);
    setDisableFolloupButton(disableFolloupButton ? false : true);
  };

  const onSelectedModel = (selectedModelId, selectedModelName) => {
    setSelectedModelId(selectedModelId);
    setSelectedModelName(selectedModelName);
  }

  return (
    <>
      {isMksChatEnable && isSkillChatEnable && (
        <div className="chat-terminal-header">
          <div
            className={`${!isMKSProcessing && isSkillProcessing ? "disabled-element" : ""
              }`}
          >
            <div
              onClick={() => handleMKSChat()}
              aria-current="page"
              className={`terminal-button w-button ${!isMKSProcessing && isSkillProcessing ? "disabled-div" : ""
                } ${isMKSChat ? "w--current" : ""} `}
            >
              MKS Chat
            </div>
          </div>
          <div
            className={`${isMKSProcessing && !isSkillProcessing ? "disabled-element" : ""
              }`}
          >
            <div
              onClick={() => handleSkillChat()}
              className={`terminal-button w-button ${isMKSProcessing && !isSkillProcessing ? "disabled-div" : ""
                } ${!isMKSChat ? "w--current" : ""} `}
            >
              Skills Chat
            </div>
          </div>
        </div>
      )}
      {!isFileTypeChat && models?.length > 0 && (
        <div>
          <SelectBySkillModel
            modelsData={models}
            onSelectedModel={onSelectedModel}
            selectedSkill={selectedSkill}
          >
          </SelectBySkillModel>
        </div>
      )}
      {showFollowupQuestion && (
        <div
          className={`${isMKSProcessing || isSkillProcessing ? "disabled-element" : ""
            }`}
        >
          <div
            className={`show-followup-btn ${isMKSProcessing || isSkillProcessing || isMessageTyping
              ? "disabled-div"
              : ""
              }`}
          >
            <div
              onClick={() => disabledFollowupButton()}
              className={`follow-up-icon ${disableFolloupButton ? "follow-up-icon-blur" : ""
                }`}
              data-follow="Follow up Question"
            ></div>
          </div>
        </div>
      )}

      {(isMksChatEnable || isSkillChatEnable) && (
        <ChatBox
          setSelectedModelId={setSelectedModelId}
          modelData={models}
          selectedModelId={selectedModelId}
          selectedModelName={selectedModelName}
          chatMessage={message}
          isMKSChat={isMKSChat}
          setIsSkillChat={setIsSkillChat}
          defaultSkillWelMessage={defaultSkillWelMessage}
          setDefaultSkillWelMessage={setDefaultSkillWelMessage}
          isFileType={isFileType}
          setIsClearChat={setIsClearChat}
          isClearChat={isClearChat}
          isChatVisible={isChatVisible}
          showHideClearChatBtn={showHideClearChatBtn}
          openPdfViewer={openPdfViewer}
          setOpenPdfViewer={setOpenPdfViewer}
          setIsFileTypeChat={setIsFileTypeChat}
          isFileTypeChat={isFileTypeChat}
          isMKSProcessing={isMKSProcessing}
          setIsMKSProcessing={setIsMKSProcessing}
          isSkillProcessing={isSkillProcessing}
          setIsSkillProcessing={setIsSkillProcessing}
          setIsMessageTyping={setIsMessageTyping}
          isMessageTyping={isMessageTyping}
          setDisableRegenerateButton={setDisableRegenerateButton}
          setDisableStopGenerateButton={setDisableStopGenerateButton}
          disableRegenerateButton={disableRegenerateButton}
          disableStopGenerateButton={disableStopGenerateButton}
          showFollowupQuestion={showFollowupQuestion}
          setDisableFolloupButton={setDisableFolloupButton}
          disableFolloupButton={disableFolloupButton}
          setShowFollowupQuestion={setShowFollowupQuestion}
          setSelectedSkill={setSelectedSkill}
          isAllowedMessageStreaming={isAllowedMessageStreaming}
          matchedSkill={matchedSkill}
          skillData={skillData}
        />
      )}
    </>
  );
};

export default ChatTerminalHeader;
